import React from 'react';
import isEmail from 'validator/lib/isEmail';
import posed, { PoseGroup } from 'react-pose';

import "./assets/tether/tether.min.css";
import 'bootstrap/dist/css/bootstrap.css';
//import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-reboot.min.css";

const hasContent = value => (value.length >= 3 ? true : false);

const validate = (value, type) =>
  (type === 'email' ? isEmail(value) : hasContent(value));

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

const Message = posed.div({
  enter: {
    opacity: 1,
    height: 'auto',
    transition: { duration: 500 },
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: { duration: 500 },
  },
});

export default class Forma extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sent: false,
      error: false,
      inquiry: 'general',
      role: '',
      fName: '',
      fNameValid: null,
      lName: '',
      lNameValid: null,
      email: '',
      emailValid: null,
      message: '',
      messageValid: null,
    };
  }

  /* Here’s the juicy bit for posting the form submission */

  handleSubmit = e => {
    if (
      this.state.fNameValid &&
      this.state.lNameValid &&
      this.state.emailValid &&
      this.state.messageValid
    ) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": "contact",
          fName: this.state.fName,
          lName: this.state.lName,
          email: this.state.email,
          message: this.state.message,
          inquiry: this.state.inquiry,
          role: this.state.role
        }),
      })
      .then(() => this.setState({
        sent: true,
        error: false,
        fName: '',
        fNameValid: null,
        lName: '',
        lNameValid: null,
        email: '',
        emailValid: null,
        message: '',
        messageValid: null,
      }, () => setTimeout(() => this.setState({ sent: false }), 3500)))
      .catch(() => this.setState({
        sent: false,
        error: 'Ooops... Došlo je do greške, molimo Vas da pokušate ponovo.',
      }));
    } else {
      this.setState(prevState => ({
        sent: false,
        error: 'Molimo Vas da popunite sva polja.',
        fName: prevState.name,
        fNameValid: prevState.nameValid || false,
        lName: prevState.name,
        lNameValid: prevState.nameValid || false,
        email: prevState.email,
        emailValid: prevState.emailValid || false,
        message: prevState.message,
        messageValid: prevState.messageValid || false,
      }));
    }

    e.preventDefault();
    console.log(this.state);
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [`${e.target.name}Valid`]: validate(e.target.value, e.target.type),
    });
  }

  handleInquiry = ({ target }) => this.setState({ inquiry: target.value });

  handleRoles = ({ target }) =>this.setState({ role: target.value });

  render() {
    const { fName, lName, email, message, inquiry, sent, error } = this.state;
    return (
      <form
        name="contact"
        method="POST"
        onSubmit={this.handleSubmit}
      >
        <input type="hidden" name="form-name" value="contact" />
       <p>
          <label>Vi ste:
            <br/>
            <select onChange={this.handleRoles} name="role[]" multiple>
              <option value="leader">Poslovni korisnik</option>
              <option value="follower">Privatni korisnik</option>
            </select>
          </label>
        </p>
        <p>
          <label>
            <input
              type="radio"
              name="inquiry[]"
              value="general"
              onChange={this.handleInquiry}
              checked={inquiry === 'general'}
            />
            informacija
          </label>
        </p>
        <p>
          <label>
            <input
              type="radio"
              name="inquiry[]"
              value="quote"
              onChange={this.handleInquiry}
              checked={inquiry === 'quote'}
            />
           porudžbina
          </label>
          </p>
       <p>
          <label>
            Ime:
            </label>
            <label>
            <input type="text" name="fName" value={fName} onChange={this.handleChange} />
          </label>
       </p>
       <p>
          <label>
            Prezime:
            </label>
            <label>
            <input type="text" name="lName" value={lName} onChange={this.handleChange} />
          </label>
        </p>
        <p>
          <label>
            Email:
            </label>
            <label>
            <input type="email" name="email" value={email} onChange={this.handleChange} />
          </label>
        </p>
        <p>
          <label>
            Poruka i kontakt telefon:
            </label>
            <label>
            <textarea name="message" value={message} onChange={this.handleChange} />
          </label>
          </p>
        <div>
          <PoseGroup flipMove={false}>
            {sent &&
              <Message key="message-sent">
                {'Hvala što ste nas kontaktirali, neko će Vam se uskoro javiti!'}
              </Message>
            }
            {error &&
              <Message key="message-error">
                {error}
              </Message>
            }
          </PoseGroup>
        </div>
        <p>
          <button name="submit" type="submit">Pošalji</button>
        </p>
      </form>
    );
  }
}